module.exports = __webpack_public_path__ + "images/jobs/cmQualite.359d1cbc.jpg";